/**
 * QuestionBlock
 * Numbered question wrapper used for all 5 survey questions.
 * Renders the navy circle number badge + question text + optional sub-hint.
 */
export default function QuestionBlock({ number, question, hint, children }) {
    return (
        <div>
            <div className="flex items-start gap-2 mb-0.5">
                <div
                    className="flex items-center justify-center flex-shrink-0 rounded-full text-xs font-semibold text-white"
                    style={{ width: 20, height: 20, background: '#1B2F7E', marginTop: 1 }}
                    aria-hidden="true"
                >
                    {number}
                </div>
                <p className="text-sm font-semibold leading-snug" style={{ color: '#1B2F7E' }}>
                    {question}
                </p>
            </div>
            {hint && (
                <p className="text-xs mb-1 ml-7" style={{ color: '#6b8fa8' }}>
                    {hint}
                </p>
            )}
            <div className="ml-7 mt-1">
                {children}
            </div>
        </div>
    );
}
